import { ReactNode, useRef } from 'react';
import Constants from '../../utils/Constants';
import { motion, useScroll, useTransform } from 'framer-motion';

const ParalaxSeparator = ({
  topColor,
  bottomColor,
  children,
}: {
  topColor?: string;
  bottomColor?: string;
  children: ReactNode;
}) => {
  const container = useRef(null);

  const { scrollYProgress } = useScroll({
    target: container,
    offset: ['start end', 'end start'],
  });

  const sm = useTransform(scrollYProgress, [0, 1], [0, -300]);

  return (
    <div className='paralax' ref={container}>
      <motion.div className='paralax_children' style={{ y: sm }}>
        {children}
      </motion.div>
      {topColor && (
        <div className='paralax_top'>
          {Constants.separatorColoredDown(topColor)}
        </div>
      )}
      {bottomColor && (
        <div className='paralax_bottom'>
          {Constants.separatorColoredUp(bottomColor)}
        </div>
      )}
    </div>
  );
};

export default ParalaxSeparator;
